<template>
  <div class="sip_slider_goal_w" :data-id="`slide-${index}`">
    <div flex center  class="sip_step_icons1">
      <div @mouseover="onActive(0)" class="sip_step_icons1_item">
        <div v-html="icons.ico1" class="sip_step_icons1_item_icon" />
        <div class="sip_step_icons1_item_text">
          Стать сильнее и выносливее
        </div>
      </div>
      <div @mouseover="onActive(1)" class="sip_step_icons1_item">
        <div v-html="icons.ico2" class="sip_step_icons1_item_icon" />
        <div class="sip_step_icons1_item_text">
          повысить гибкость
        </div>
      </div>

      <div @mouseover="onActive(2)" class="sip_step_icons1_item">
        <div v-html="icons.ico2" class="sip_step_icons1_item_icon" />
        <div class="sip_step_icons1_item_text">
          двигаться по-новому
        </div>
      </div>

      <div @mouseover="onActive(3)" class="sip_step_icons1_item">
        <div v-html="icons.ico2" class="sip_step_icons1_item_icon" />
        <div class="sip_step_icons1_item_text">
          Сохранить форму
        </div>
      </div>

      <div @mouseover="onActive(4)" class="sip_step_icons1_item">
        <div v-html="icons.ico2" class="sip_step_icons1_item_icon" />
        <div class="sip_step_icons1_item_text">
          Снизить вес
        </div>
      </div>

    </div>


    <div ref="control" class="sip_slider_goal_control">
      <div>
        <svg width="23" height="40" viewBox="0 0 23 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 20L23 0V40L0 20Z" fill="#8F9EAB"/>
        </svg>
      </div>
      <div>
        <svg width="23" height="40" viewBox="0 0 23 40" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M23 20L-1.90735e-06 0V40L23 20Z" fill="#8F9EAB"/>
        </svg>
      </div>
    </div>


    <div ref="slider" class="sip_slider_goal" >

      <div
        v-for="slide of slides"
        :key="slide.id"
        class="sip_slider_item_w"
      >
        
        <div class="sip_slider_item">
          <div class="sip_slider_item_image" >
            <img :src="`${$server}${slide.img}`" />
          </div>
          <div class="sip_slider_item_text" >
            <div class="sip_slider_item_title" v-html="slide.title"/>
            <div class="sip_slider_item_body">
              <div>Вид активности:</div>
              <div class="sip_slider_item_body_b" v-html="slide.bodyTop" />
              <div v-if="slide.bodyBottom">Оптимальная частота сердечных сокращений:</div>
              <div class="sip_slider_item_body_b" v-html="slide.bodyBottom" />
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
import { tns } from "../../node_modules/tiny-slider/src/tiny-slider"
import { icons } from '../elements.js'

export default {
  name: 'slider',
  data () {
    return {
      icons,
      index: 0,
      elSlider: null,
      slides: [
        {
          id: 1,
          title: `Стать сильнее и выносливее`,
          img: 's1.png',
          bodyTop: `
            <ul>
              <li>
                Функциональный тренинг (комплекс на основе повседневных движений человека)
              </li><li>
                Круговая тренировка (многократное выполнение набора упражнений с короткими перерывами)
              </li>
            </ul>
          `,
          bodyBottom: `160–180 ударов/мин.`
        },{
          id: 2,
          title: `Разгрузить нервную систему, повысить гибкость`,
          img: 's5.png',
          bodyTop: `
            <ul>
              <li>
                Пилатес (медленные, плавные движения с концентрацией на дыхании)
              </li><li>
                Йога
              </li><li>
                Стретчинг (упражнения на растяжку)
              </li>
            </ul>
          `,
          bodyBottom: null
        },{
          id: 3,
          title: `Научиться двигаться по-новому`,
          img: 's4.png',
          bodyTop: `
            <ul>
              <li>
                Различные виды танцев
              </li><li>
                Танцевальная аэробика
              </li><li>
                Зумба (активная тренировка с элементами сальсы, фламенко, хип-хопа и других направлений)
              </li>
            </ul>
          `,
          bodyBottom: null
        },{
          id: 4,
          img: 's3.png',
          title: `Сохранить форму`,
          bodyTop: `
            <ul>
              <li>
                Среднеинтенсивные тренировки, например лёгкий бег
              </li>
            </ul>
          `,
          bodyBottom: `120–140 ударов/мин.`
        },{
          id: 5,
          title: `Снизить вес`,
          img: 's2.png',
          bodyTop: `
            <ul>
              <li>
                Аэробика
              </li><li>
                Силовые тренировки с собственным весом и дополнительной нагрузкой (гантелями, тренажёрами)
              </li>
            </ul>
          `,
          bodyBottom: `120 ударов/мин.`
        }
      ]
    }
  },
  mounted () {
    let autolpay = this.$isMob ? false : true;

    setTimeout(() => {
        let container = this.$refs.slider
        this.elSlider = tns({
            container: container,
            items: 1,
            controlsContainer: this.$refs.control,
            mode: "gallery",
            loop: true,
            mouseDrag: true,
            touch: true,
            // autoplayButton: '.sip_slider_goal_btn_autoplay',
            preventScrollOnTouch: 'auto', // исправляет ошибку "Unable to preventDefault inside passive event listener invocation"
            autoplay: autolpay,
            autoplayTimeout: 8000,
            onInit: function() {
              console.log('init')
              container.style.display = 'block'
            },
            onIndexChanged: function() {
              console.log('indexChanged')
            }
        });

        if(!this.$isMobile) {
          this.elSlider.events.on('indexChanged', ()=>{
            this.index = this.elSlider.getInfo().navCurrentIndex
            this.$emit('clicked', this.index)
          });
        }

    }, 0);

  },
  methods: {
    onActive(val) {
      
      if(!this.$isMobile) {
        this.elSlider.goTo(val)
      }
      // console.log(val)
    }
  }
}
</script>
<style lang="stylus">
@import "https://cdnjs.cloudflare.com/ajax/libs/tiny-slider/2.9.2/tiny-slider.css"

.tns-nav
  .tns-controls
    display none

.tns-outer
  button[type="button"]
    display none

.sip_slider_goal_w
  .tns-nav
    display none

.sip_slider_goal_w
  // max-width 960px
  max-width 895px
  width 100%
  margin 0 auto
  font-family Montserrat
  font-style normal
  font-weight normal
  color #362B2B
  position relative
  z-index 2
  .sip_slider_goal
    padding 32px 38px
    // background: rgba(255, 0, 0, 0.1);
    @media screen and (max-width: 900px)
      padding-left 20px
      padding-right 20px
  .sip_slider_item
    display flex
    @media screen and (max-width: 900px)
      flex-direction column
  .sip_slider_item_image
    max-width 300px
    width 100%
    img
      width 100%
  .sip_slider_item_text
    max-width 540px
    width 100%
    padding-top 15px
    padding-left 15px
    @media screen and (max-width: 900px)
      padding 0 10px
  .sip_slider_item_title
    font-weight bold
    font-size 36px
    line-height 36px
    margin-bottom 24px
    @media screen and (max-width: 900px)
      font-size 18px
      line-height 18px

  .sip_slider_item_body
    font-size 16px
    line-height 24px
    @media screen and (max-width: 900px)
      font-size 3.2vw
      line-height 4.8vw

  .sip_slider_item_body_b
    padding 1px 0 10px 0
    font-weight bold
    @media screen and (max-width: 900px)
      font-size 3.75vw
      line-height 5.7vw
    ul
      list-style-type square
      padding 0
      margin 0
      li
        margin-bottom 2px
      @media screen and (max-width: 900px)
        list-style none

.sip_step_icons1
  display flex
  justify-content space-between
  padding-bottom 32px
  @media screen and (max-width: 900px)
    display none
  .sip_step_icons1_item
    max-width 180px
    width 100%
    text-align center
    font-family Montserrat
    font-style normal
    font-weight normal
    font-size 14px
    line-height 21px
    text-align center
    text-transform uppercase
    color #362B2B
    cursor pointer
    transition .3s
    img
      border-radius 50%
    .sip_step_icons1_item_icon
      position relative
      display inline-block
      &:before
        content ''
        position absolute
        top -15px
        left -15px
        width 84px
        height 84px
        border 5px solid #E5E5E5
        border-radius 50%
        transition opacity .5s
        opacity 0
    .sip_step_icons1_item_text
      margin-top 12px

    &:hover
      font-weight bold

.sip_slider_item_w
  .sip_slider_item_image
    transition 1s
    // transition-delay .2s
    // opacity 0
    transform scale(0.9)
    @media screen and (max-width: 900px)
      margin 0 auto
      max-width 70vw
      margin-bottom 3vw
  .sip_slider_item_title
    transition 1s
    // opacity 0
    transform translateY(50px)
  .sip_slider_item_body
    transition 1s
    transition-delay .1s
    // opacity 0
    transform translateY(50px)


for num in 0 1 2 3 4
  [data-id=slide-{num}]
    .sip_step_icons1_item:nth-child({num + 1})
      font-weight bold
      .sip_step_icons1_item_icon
        &:before
          opacity 1
    .sip_slider_item_w:nth-child({num + 1})
      .sip_slider_item_title
        // opacity 1
        transform translateY(0)
      .sip_slider_item_body
        // opacity 1
        transform translateY(0)
      .sip_slider_item_image
        // opacity 1
        transform scale(1)


.sip_slider_goal_control
  display none
  div
    position absolute
    top 40vw
    outline none
    z-index 4
    &:nth-child(1)
      left 10px
    &:nth-child(2)
      right 10px
  @media screen and (max-width: 900px)
    display block
  

//   .sip_step_icons1_item:nth-child(1)
// 	  font-weight: bold;

// [data-id='slide-1']
//   .sip_step_icons1_item:nth-child(2)
//     font-weight: bold;

// [data-id='slide-2']
//   .sip_step_icons1_item:nth-child(3)
// 	  font-weight: bold;

// [data-id='slide-3']
//   .sip_step_icons1_item:nth-child(4)
// 	  font-weight: bold;

// [data-id='slide-4']
//   .sip_step_icons1_item:nth-child(5)
// 	  font-weight: bold;


</style>